export const MIXPANEL_EVENTS_NAMING = {
  // ----- Annotation Explorer Specific
  CARD_CLICKED: {
    eventName: "Card Clicked",
    properties: {
      FEATURE: "Feature",
      CONTENT_TYPE: "Content Type",
      CONTENT_TITLE: "Content Title",
      ANNOTATION: "Annotation",
      // Where the card was shown, when not on the Annotation Explorer page itself
      SURFACE: "Surface",
      WIDGET: "Widget",
      REPORT_ID: "Report ID",
      WIDGET_ID: "Widget ID",
      WIDGET_INDEX: "Widget Index",
    },
  },
};
